/** Staff membership comes from the authenticated session's municipality claims. */
export function canViewChangelog(user) {
  return user?.isAdmin === true || assignedMunicipalities(user).length > 0;
}

function assignedMunicipalities(user) {
  return Array.isArray(user?.cities)
    ? user.cities.filter(id => typeof id === 'string' && id.trim().length > 0)
    : [];
}

/** Apply both entry restrictions before rendering headings, counts, or content. */
export function visibleChangelogReleases(changelog, user) {
  if (!canViewChangelog(user)) return [];

  const isAdmin = user.isAdmin === true;
  const cities = new Set(assignedMunicipalities(user));

  return changelog.releases.flatMap(release => {
    const entries = release.entries.filter(entry => {
      if (isAdmin) return true;
      const audience = entry.audience === undefined ? changelog.audience : entry.audience;
      if (!Array.isArray(audience) || !audience.includes('staff')) return false;
      if (entry.municipalityIds === undefined) return true;
      return Array.isArray(entry.municipalityIds)
        && entry.municipalityIds.some(id => cities.has(id));
    });

    if (!entries.length) return [];
    return [{
      ...release,
      // A summary may mention an admin-only or another municipality's update.
      title: entries.length === release.entries.length ? release.title : null,
      entries
    }];
  });
}
